<!-- <div class="row">
   <div class="col">
      <img class="image" src="../../../assets/images/office.jpeg">
   </div>
   <div class="col p15_2 " style="overflow: hidden">
      <div class="row">
         <div class="col text-align-center p5">
            <img class="logo" src="../../../assets/images/gentari_logo.svg">
         </div>
      </div>
      <div class="row">
         <div class="col heading">
            Gentari Empower
         </div>
      </div>
      <div class="row">
         <div class="col tag-line">
            Your Employee Experience Platform
         </div>
      </div>
      <div class="row">
         <div class="col text">
            <br /><br />
         </div>
      </div>
      <div class="row">
         <div class="col p07">
            <button class="btn login" (click)="login()"> <i class="fa fa-windows" aria-hidden="true"></i> Log In
            with Microsoft</button>
         </div>
      </div>
   </div>
</div>

 -->


<div class="page-wrapper">
   <div class="container">
      <div class="row">
         <!-- First Column: Image with Shine Effect -->
         <div class="col-sm-6">
            <div class="image-wrapper">
               <img src="../../../assets/images/gen_g_logo.webp" class="animated-image shine-effect"
                  alt="Gentari Empower Logo">
            </div>
         </div>
         <!-- Second Column: OTP Form with Slide Animation -->
         <div class="col-sm-6"
            style="background-color: #f6f7f729;padding-top: 40px;border-radius: 7px;padding-left: 70px;padding-right: 70px;">
            <div class="row">
               <div class="col-12">
                  <div class="col text-align-center p5">
                     <img class="logo" src="../../../assets/images/gentari_logo.svg">
                  </div>
                  <h3>Gentari Empower</h3>
               </div>
            </div>
            <!-- Hidden checkbox for toggling forms -->
            <input type="checkbox" id="toggle-otp">
            <div class="otp-container">
               <!-- Email Input Form -->
              <div class="form-slide">
                    <div class="form-group">
                        <label for="emailInput">Enter Email</label>
                        <input type="email" class="form-control"
                            id="emailInput"
                            name="email"
                            [(ngModel)]="email"
                            #emailRef="ngModel"
                            placeholder="your.email@example.com"
                            required
                            email   autocomplete="off"/>
                        <!-- Validation error message -->
                        <div *ngIf="emailRef.invalid && emailRef.touched" class="text-danger">
                        <small *ngIf="emailRef.errors?.['required']">Email is required.</small>
                        <small *ngIf="emailRef.errors?.['email']">Enter a valid email.</small>
                        </div>
                    </div>
                    <button class="btn btn-primary" [disabled]="emailRef.invalid" (click)="sendOtp()">Send OTP</button>
                    </div>
               <!-- OTP Input Form with Back Arrow -->
            <div class="otp-slide" *ngIf="showOtpSection">
                                 <!-- Use a label to uncheck the toggle-otp checkbox -->
                  
                  <div class="form-group">
                     <label for="toggle-otp" class="back-arrow" (click)="hideOtpSection()"> &#8592; <i class="bi bi-arrow-left" ></i>  Enter OTP</label>
                     <div class="otp-inputs">
                        <input type="text" maxlength="1" class="form-control otp-input"
                        [(ngModel)]="otpInputs[0]" (input)="focusNext($event, 1)" autocomplete="off">
                        <input type="text" maxlength="1" class="form-control otp-input"
                        [(ngModel)]="otpInputs[1]" (input)="focusNext($event, 2)" autocomplete="off">
                        <input type="text" maxlength="1" class="form-control otp-input"
                        [(ngModel)]="otpInputs[2]" (input)="focusNext($event, 3)" autocomplete="off">
                        <input type="text" maxlength="1" class="form-control otp-input"
                        [(ngModel)]="otpInputs[3]" autocomplete="off">
                     </div>
                  </div>
                  <button class="btn btn-primary" (click)="verifyOtp()">Verify</button>
                  <button class="btn btn-secondary" [disabled]="resendDisabled" (click)="resendOtp()">
                  Resend OTP <span *ngIf="resendDisabled">({{ counter }}s)</span>
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>